import { Check } from '@chain-zen/ui'

import type { TSFTPSource } from '../../../types/tracking'
import { TrackingSourceRow } from '../tracking-source-row'
import { TrackingTimeDisplay } from '../tracking-time-display'
import { SFTPIcon } from './sftp-icon'

interface ISFTPInfoProps {
  shipmentID: string
  trackingSourceData: TSFTPSource
}

/**
 * This component is used to display the SFTP tracking source information.
 */
export const SFTPInfo = (props: ISFTPInfoProps) => {
  const { trackingSourceData } = props
  const lastLocation =
    trackingSourceData?.locations && trackingSourceData.locations.length > 0
      ? trackingSourceData.locations[trackingSourceData.locations.length - 1]
      : null

  return (
    <TrackingSourceRow className="px-2">
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-1 flex-wrap">
          <Check className="h-3 w-3 shrink-0 self-center text-green-500 dark:text-green-400" />
          <SFTPIcon size={3} />
          <span className="text-sm font-medium text-foreground">
            Tracking sent by {trackingSourceData?.metadata?.sender?.sftpUsername || 'carrier'} via SFTP
          </span>
          {!!lastLocation && (
            <TrackingTimeDisplay
              filterReason={trackingSourceData.filterReason}
              lastLocationCity={lastLocation.city}
              lastLocationFetchedAt={trackingSourceData.lastLocationFetchedAt}
              lastLocationStateCode={lastLocation.stateCode}
              lastLocationTimestamp={lastLocation.timestamp}
              wrapper="div"
              className="text-xs text-muted-foreground"
            />
          )}
        </div>

        <div className="flex items-center gap-1 text-xs text-muted-foreground flex-wrap">
          {!!trackingSourceData?.metadata?.sender?.truckNumber && (
            <span>Truck: {trackingSourceData.metadata.sender.truckNumber}</span>
          )}
          {!!trackingSourceData?.metadata?.sender?.truckNumber &&
            !!trackingSourceData?.metadata?.sender?.trailerNumber && <span className="text-muted-foreground">•</span>}
          {!!trackingSourceData?.metadata?.sender?.trailerNumber && (
            <span>Trailer: {trackingSourceData.metadata.sender.trailerNumber}</span>
          )}
        </div>
      </div>
    </TrackingSourceRow>
  )
}
